module.exports = "/React/dist/6fb9a093a67d1cbd0b748d1c18fcdc72.png";